"use strict"

import "../extend/date.js";
import { LabeledTextInput } from "../labeledTextInput.js";
import {ModalShowInfo} from "../modals/modalShowInfo.js";
import { ModalSelectTimeFrame } from "../modals/modalSelectTimeFrame.js";
import {DataView} from '../dataview.js';
import { ModalMenu } from "../modals/modalMenu.js";
import { ModalEditPupilNote } from "../modals/modalEditPupilNote.js";
import { ModalEditSmartphoneViolationNote } from "../modals/modalEditSmartphoneNote.js";
import { ModalEditReprimand } from "../modals/modalEditReprimand.js";
import { sortTeacherByShort, sortPupilByClassAndName, sortClass, sortRoom } from "../util.js";
import { formatLink } from "../util.js";
import { ClassNote } from "../classNote.js";
import { TimetableLesson } from "../timetableLesson.js";
import { TimetableSubstitution } from "../timetableSubstitution.js";
import { TimetableLessonGroup } from "../timetableLessonGroup.js";
import { TimetableManager } from "../timetableManager.js";

export class Timetable {

   constructor(app) {
      this.app = app;
      this.dm = app.dm;

      this.tab = document.querySelector('.main-item[tab-name="timetable"]');
      this.table = this.tab.querySelector('.timetable-grid');
      this.title = this.tab.querySelector('.title .title-content');
      this.elResults = this.tab.querySelector('.search-results');
      this.elMain = this.tab.querySelector('.main-content');
      this.elInfo = this.tab.querySelector('.main-content .info');
      this.hourRows  = [0, 3, 4, 6, 7, 9, 10, 12, 13, 14, 15, 16, 17];
      this.currentMonday = Date.getMondayOfCurrentWeek();
      this.dayColumnWidths = [0, 1, 1, 1, 1, 1];
      this.currentMonday.setDate(this.currentMonday.getDate());

      this.gridPositions = {
         weekday: [2,3,4,5,6],
         hour:    [3,4,6,7,9,10,12,13,14,15],
         watches: [2, 5, 8, 11]
      };

      const cb = (value) => {
         this.searchTimetable(value);
      };

      this.txtSearch = new LabeledTextInput('.main-item.timetable .txt-search', { labelText: 'Suche'/*, onChanging: cb*/ });
      document.querySelector('.main-item.timetable .txt-search').oninput = event => this.searchTimetable(event.target.value);

      this.tab.querySelector('.btn-my').addEventListener('click', event => {
         this.loadTimetable(this.user);
      });

      this.tab.querySelector('.btn-prev').addEventListener('click', event => {
         if (!event.target.classList.contains('disabled')) this.loadNeighbour('prev');
      });

      this.tab.querySelector('.btn-next').addEventListener('click', event => {
         if (!event.target.classList.contains('disabled')) this.loadNeighbour('next');
      });

      this.tab.querySelector('.btn-date-prev').addEventListener('click', event => {
         if (!event.target.classList.contains('disabled')) this.loadNeighbourWeek('prev');
      });

      this.tab.querySelector('.btn-date-next').addEventListener('click', event => {
         if (!event.target.classList.contains('disabled')) this.loadNeighbourWeek('next');
      });

      this.tab.querySelector('.date .date-content').addEventListener('click', event => {
         this.setMode('current');
      });

      this.tab.querySelector('.date .btn-regular').addEventListener('click', event => {
         this.setMode('regular');
      });

   }

   refresh() {
      this.selectCurrentHour();
   }

   setMode(mode) {
      this.mode = mode;
      if (this.mode === 'regular') {
         this.tab.querySelector('.btn-date-prev').classList.add('disabled');
         this.tab.querySelector('.btn-date-next').classList.add('disabled');
         this.tab.querySelector('.date .btn-regular').classList.add('selected')
         this.tab.querySelector('.date .date-content').classList.remove('selected');
         
      }
      else {
         this.tab.querySelector('.btn-date-prev').classList.remove('disabled');
         this.tab.querySelector('.btn-date-next').classList.remove('disabled');
         this.tab.querySelector('.date .btn-regular').classList.remove('selected')
         this.tab.querySelector('.date .date-content').classList.add('selected');
      }

      this.loadTimetable(this.result);

   }

   selectCurrentHour() {

      this.table.querySelectorAll('.current').forEach(item => item.classList.remove('current'));

      if (!this.timeFrames) return;

      const currentDate = new Date();
      let currentTimeString = currentDate.getHours().pad(2, '0') + ':' + currentDate.getMinutes().pad(2, '0');

      for (let i=0; i<this.timeFrames.length; ++i) {
         if (currentTimeString >= this.timeFrames[i].normStart && currentTimeString <= this.timeFrames[i].normEnd) {
            const elCell = this.table.querySelector('.sel-' + (currentDate.getWeekday() + 1) + '-' + (i + 1));
            if (elCell) elCell.classList.add('current');
         }
      }

      for (let i=0; i<this.timeFramesBreak.length; ++i) {
      //for (const i of this.gridPositions.watches) {
         if (currentTimeString >= this.timeFramesBreak[i].start && currentTimeString <= this.timeFramesBreak[i].end) {
            const elCell = this.table.querySelector('.sel-b-' + (currentDate.getWeekday() + 1) + '-' + i);
            if (elCell) elCell.classList.add('current');
         }
      }

   }

   showSearchResults(show) {
      this.elResults.style.display = show ? 'block' : 'none';
      this.elMain.style.display = show ? 'none' : 'flex';
   }

   searchTimetable(searchValue) {

      this.elResults.empty();

      // leeres Suche: Stundenplan wieder anzeigen
      if (searchValue.length === 0) {
         this.showSearchResults(false);
      }

      // Damit eine Suche durchgeführt werden muss, muss der Suchstring entweder länger als 2 Zeichen sein oder mit einer Zahl beginnen
      if (searchValue.length < 2 && searchValue.search(/^ *\d/) === -1) return;

      searchValue = searchValue.toUpperCase();

      const users = this.dm.getUsers();
      const classes = this.dm.getClasses();
      const rooms   = this.dm.getRooms();
      const courses = this.dm.getCourses();

      let results = [];

      let re = new RegExp(searchValue, 'i');

      for (const userId in users) {
         const user = users[userId];
         if (user.short.toUpperCase() === searchValue) {
            let result = Object.extend(true, user, { sortOrder: 1 });
            results.push(result);
         }
         else if (user.lastName.search(re) !== -1) {
            let result = Object.extend(true, user, { sortOrder: 2 });
            results.push(result);
         }
         else if (user.firstName.search(re) !== -1) {
            let result = Object.extend(true, user, { sortOrder: 3 });
            results.push(result);
         }
      }

      for (const classId in classes) {
         const cls = classes[classId];
         if (cls.name.search(re) !== -1) {
            results.push({type: 'class', sortOrder: 1, id: cls.id, name: cls.name });
         }
      }

      for (const roomId in rooms) {
         const room = rooms[roomId];
         if (room.short.search(re) !== -1) {
            let result = Object.extend(true, room, { type: 'room', sortOrder: 3 });
            results.push(result);
         }
      }

      for (const course of courses) {
         if (['11', '12', '13'].includes(course.classNames) && course.short.search(re) !== -1) {
            let result = Object.extend(true, course, { type: 'course', sortOrder: 1 });
            results.push(result);
         }
      }

      // Wenn nur ein Ergebnis vorliegt: direkt dieses laden
      if (results.length === 0) {
         this.elResults.innerHTML = "Keine Treffer";
      }

      if (results.length === 1) {
         this.loadTimetable(results[0]);
      }
      else {
         this.showSearchResults(true);
         results.sort((a,b) => { return a.sortOrder - b.sortOrder; } );

         for (const result of results) {
            let elResult = this.elResults.createElement('div', 'search-result ' + result.type);
            if (result.type === 'teacher') {
               elResult.innerHTML = '<div class="type teacher">L</div>' + result.lastName + (result.firstName !== '' ? ', ' + result.firstName : '') + ` (${result.short})`;
            }
            else if (result.type === 'pupil') {
               const cls = this.dm.getClass(result.classId);
               const clsString = cls.year < 11 ? cls.name : cls.name + ', ' + this.app.dm.getUser(result.tutorId);
               //console.log(clsString);

               elResult.innerHTML = '<div class="type pupil">S</div>' + `${result.lastName}, ${result.firstName} (${cls.name})`;
            }
            else if (result.type === 'class') {
               elResult.innerHTML = '<div class="type class">K</div>' + result.name;
            }
            else if (result.type === 'room') {
               elResult.innerHTML = '<div class="type room">R</div>' + result.short + (result.description.length > 0 ? ' (' + result.description + ')' : '');
            }
            else if (result.type === 'course') {
               elResult.innerHTML = '<div class="type course">K</div>' + result.classNames + result.short + ` (${result.teachers.map(id => this.dm.getUser(id).short).join(',')})`;
            }

            elResult.addEventListener('click', (event) => {
               this.loadTimetable(result);
               event.stopPropagation();
            });


         }

      }

   }

   loadNeighbour(dir) {
      let index = this.result.list.findIndex(item => item.id === this.result.id);
      if (index === -1) return;

      if (dir === 'prev') {
         index = index === 0 ? this.result.list.length-1 : index - 1;
      }
      else if (dir === 'next') {
         index = index === this.result.list.length-1 ? 0 : index+1;
      }

      const item = this.result.list[index];
      item.type = this.result.type;

      this.loadTimetable(item);

   }

   loadNeighbourWeek(dir) {

      if (dir === 'prev') {
         this.currentMonday.setDate(this.currentMonday.getDate()-7);
      }
      else if (dir === 'next') {
         this.currentMonday.setDate(this.currentMonday.getDate()+7);
      }

      this.loadTimetable(this.result);

   }

   loadInfo(result) {
      this.elInfo.empty();

      if (result.type === 'class') {
         const cls = this.dm.getClass(result.id);
         this.elInfo.innerHTML += `
            <div class="fw-bold">Schüler</div>
            <div class="list-pupils"></div>
            <div class="flat-button btn-copy-pupil-emails mb-10">Schüler-Emailadressen kopieren</div>
            <div class="fw-bold">Lehrer</div>
            <div class="list-teachers"></div>
            <div class="flat-button btn-copy-teacher-emails mb-10">Lehrer-Emailadressen kopieren</div>
         `;

         const pupils   = cls.pupils.map(id => this.dm.getPupil(id));
         let listPupilsSettings = {
            columns: [
               { title: 'Nachname', data: 'lastName', sort: { index: 1, dir: 1 }, css: { height: '1.5rem' } },
               { title: 'Vorname', data: 'firstName', sort: { index: 2, dir: 1 } },
               { title: 'Email-Adresse', data: 'email', sort: { index: 3, dir: 1 } }
            ]
         };
         const listPupils = new DataView(this.elInfo.querySelector('.list-pupils'));
         listPupils.load(pupils, listPupilsSettings);

         let courseTeachers = {};
         this.dm.getCourses()
         .filter(course => course.classes.includes(cls.id))
         .map(course => {
            for (const teacherId of course.teachers) {
               if (!courseTeachers.hasOwnProperty(teacherId)) courseTeachers[teacherId] = { teacher: this.dm.getUser(teacherId), courses: [] };
               courseTeachers[teacherId].courses.push(course);
            }
         })

         courseTeachers = Object.values(courseTeachers).map(item => ({ short: item.teacher.short, subjects: item.courses.map(c => c.short).join(', '), email: item.teacher.email }));
         let listTeachersSettings = {
            columns: [
               { title: 'Kürzel', data: 'short', sort: { index: 1, dir: 1 }, css: { height: '1.5rem' } },
               { title: 'Fächer', data: 'subjects', sort: { index: 2, dir: 1 } },
               { title: 'Email-Adresse', data: 'email', sort: { index: 3, dir: 1 } }
            ]
         };
         const listTeachers = new DataView(this.elInfo.querySelector('.list-teachers'));
         listTeachers.load(courseTeachers, listTeachersSettings);

         this.elInfo.querySelector('.btn-copy-pupil-emails').onclick = () => {
            navigator.clipboard.writeText(pupils.map(pupil => pupil.email).join(','));
         }

         this.elInfo.querySelector('.btn-copy-teacher-emails').onclick = () => {
            navigator.clipboard.writeText(courseTeachers.map(teacher => teacher.email).join(','));
         }

         //cls.teachers.map(teacher => this.dm.getUser(teacher.id));




      }


   }

   async loadPupilNotes(elItems, pupilId) {

      const items = await ClassNote.loadPupilNotesByPupil(this.dm, pupilId);
      elItems.empty();

      for (let item of items) {
         try {

            let note = formatLink(item.note);

            let elItem = null;
            if (item.type === 'pupilNote' || item.type === 'smartphoneViolation' || item.type === 'reprimand') {
               const pupil = this.user.type === 'teacher' ? this.app.dm.getUser(item.pupilId) : this.user;
               const icons = { 'smartphoneViolation': '📱', 'reprimand': '⚠️'};
               const icon = item.type in icons ? icons[item.type] : '';

               elItem = elItems.createElement('div', 'class-note-item');
               elItem.innerHTML = `
                  <div class="content">
                     <span class="date">${Date.simplifyDatePeriod(item.dateFrom, item.dateTo)}</span>
                     ${icon}<span class="message">${note}</span>
                     <span class="creator">${this.dm.getUser(item.creatorId).short}</span>
                  </div>`;
            }

            if (item.syncStatus === 'delete') elItem.classList.add('deleted');

            if (this.user.hasPermission('classreg', 'edit')) {
               elItem.onclick = (event) => {
                  if (item.type === 'pupilNote') new ModalEditPupilNote(this.app, item, () => this.loadPupilNotes(elItems, pupilId));
                  else if (item.type === 'smartphoneViolation') new ModalEditSmartphoneViolationNote(this.app, item, () => this.loadPupilNotes(elItems, pupilId));
                  else if (item.type === 'reprimand') new ModalEditReprimand(this.app, item, () => this.loadPupilNotes(elItems, pupilId));
                  event.stopPropagation();
               }
               elItem.querySelectorAll('a').forEach(elA => elA.onclick = (e) => {
                  e.stopPropagation();
               });   
            }

         }
         catch (e) {
            logger.error(e);
            toast.alert("Eine Klassennotiz konnte nicht geladen werden: " + e, { duration: 8000 });
         }
      }

   }

   async loadTimetable(result) {
      this.result = result;

      let prevNext = true;
      const weekNumber = this.currentMonday.getWeekNumber();

      this.elMain.setAttribute('result-type', result.type);

      if (result.type === 'pupil' && this.user.type === 'teacher') {
         result.class = this.dm.getClass(result.classId)
      }

      const timetableManager = new TimetableManager(result, this.currentMonday, weekNumber, this.mode, this.user, this.dm) ;
      await timetableManager.loadData();

      if (result.type === 'teacher') {
         result.list = Object.values(this.dm.getTeachers()).filter(teacher => teacher.short[0] !== '*');
         result.list.sort(sortTeacherByShort);
         this.title.innerHTML = result.lastName + (result.firstName !== '' ? ', ' + result.firstName : '') + ` (${result.short})`;
      }
      else if (result.type === 'pupil') {

         result.list = Object.values(this.dm.getPupils());
         result.list.sort(sortPupilByClassAndName);
         
         const cls = '(' + this.dm.getClass(result.classId).name + (result.tutorId ? `, ${this.dm.getUser(result.tutorId).short}` : '') + ')';
         this.title.innerHTML = result.lastName + (result.firstName !== '' ? ', ' + result.firstName : '') + ` ${cls}<br>${result.short}`;
         if (this.user.type === "teacher") this.loadPupilNotes(this.elMain.querySelector('.notes .items'), result.id);

         if (this.user.hasPermission('classreg', 'edit')) {
            this.elMain.querySelector('.notes').onclick = (event) => {
               event.stopPropagation();
               const btnPos = this.elMain.querySelector('.btn-add-pupil-note').getBoundingClientRect();
               const isoDate = (new Date()).isoDate();

               const note = { pupilId: result.id, dateFrom: isoDate, dateTo: isoDate, creatorId: this.user.id };

               new ModalMenu({
                  items: [
                     { label: 'Schüler-Anmerkung', onSelect: () => new ModalEditPupilNote(this.app, note, () => this.loadTimetable(result) ) },
                     { label: '📱 Handy-Verstoß', onSelect: () => new ModalEditSmartphoneViolationNote(this.app, note, () => this.loadTimetable(result)) },
                     { label: '⚠️ Tadel', onSelect: () => new ModalEditReprimand(this.app, note, () => this.loadTimetable(result)) },
                  ],
                  position: { corner: 'top right', offset: { x: document.body.getBoundingClientRect().right - btnPos.left, y: btnPos.top } }
               });
            };
         }
         else {
            this.elMain.querySelector('.notes .icon-plus').style.display = 'none';
         }

      }
      else if (result.type === 'class') {
         result.list = Object.values(this.dm.getClasses());
         result.list.sort(sortClass);
         const cls = this.dm.getClass(result.id);
         this.title.innerHTML = result.name + (cls.formTeachers.length > 0 ? ' (Klassenleitung: ' + cls.formTeachers.map((teacherId) => { return this.dm.getUser(teacherId).lastName}).join(', ') + ')' : '');
      }
      else if (result.type === 'room') {
         result.list = Object.values(this.dm.getRooms());
         result.list.sort(sortRoom);
         this.title.innerHTML = result.short + (result.description ? ' (' + result.description + ')' : '');
      }
      else if (result.type === 'course') {
         prevNext = false;
         this.title.innerHTML = result.classNames + result.short + ` (${result.teachers.map(id => this.dm.getUser(id).short).join(',')})`;
      }

      this.tab.querySelectorAll('.btn-prev, .btn-next').forEach(elBtn => {
         if (prevNext) elBtn.classList.remove('disabled');
         else elBtn.classList.add('disabled');
      });


      this.loadInfo(result);

      this.showSearchResults(false);

      this.table.empty();
      this.table.classList.add(this.user.type);

      const dayNames = ['W' + weekNumber, 'Mo', 'Di', 'Mi', 'Do', 'Fr'];
      
      const date = new Date(this.currentMonday);
      for (let i=0; i<dayNames.length; ++i) {
         const elDay = this.table.createElement('div', 'timetable-cell day-name');
         elDay.setStyles({ gridArea: `1 / ${i+1}` });
         if (i===0) {
            elDay.innerHTML = `<div class="center-h">${dayNames[i]}</div>`;
            elDay.onclick = (e) => {
               this.dayColumnWidths = [0, 1, 1, 1, 1, 1];
               this.table.style.gridTemplateColumns = this.dayColumnWidths.map(c => c + 'fr').join(' ');
            }
         }
         else {
            elDay.innerHTML = `<div class="center-h">${dayNames[i]}  ${date.getDate()}</div>`;
            date.nextDay();
            elDay.onclick = (e) => {
               if (this.dayColumnWidths[i] === 1) {
                  this.dayColumnWidths = this.dayColumnWidths.map((w,d) => d === i ? 4 : (d === 0 ? 0 : 1));
                  this.table.style.columnGap = '2px';
               }
               else if (this.dayColumnWidths[i] === 4) {
                  this.dayColumnWidths = this.dayColumnWidths.map((w,d) => d === i ? 5 : (d === 0 ? 0 : 0));
                  this.table.style.columnGap = 0;
               }
               else {
                  this.dayColumnWidths = [0,1,1,1,1,1];
                  this.table.style.columnGap = '2px';
               }
               this.table.style.gridTemplateColumns = this.dayColumnWidths.map(c => c + 'fr').join(' ');
            };

         }
      }

      date.prevDay();
      const dateRange = Date.simplifyDatePeriod(this.currentMonday.isoDate(), date.isoDate());
      this.elMain.querySelector('.date .date-content').innerText = dateRange;

      const timeFrames = this.dm.getTimeFrames('regular');
      this.timeFrames = timeFrames.am;
      this.timeFramesBreak = timeFrames.break;

      if (this.user.type === 'pupil') {
         if (this.user.class.year < 11) {
            this.timeFrames = this.timeFrames.concat([timeFrames.sek1_7]);
         }
         else {
            this.timeFrames = this.timeFrames.concat(timeFrames.pm);
         }
      }
      else {
         this.timeFrames = this.timeFrames.concat(timeFrames.pm);
      }

      this.timeFrames.map(tf => {
         tf.normStart = (tf.start.length == 4 ? ('0' + tf.start) : tf.start);
         tf.normEnd   = (tf.end.length == 4 ? ('0' + tf.end) : tf.end);
      });

      for (let hour=0; hour<10; ++hour) {
         const elHour = this.table.createElement('div', 'timetable-cell hour-name');
         elHour.setStyles({
            gridArea: `${this.hourRows[hour+1]} / 1`
         });
         elHour.innerHTML = this.timeFrames[hour] ? `<div class="timeframe">${this.timeFrames[hour].start}</div><div class="hour">${hour+1}</div><div class="timeframe">${this.timeFrames[hour].end}</div>` : hour + 1;
      }

      for (let i of this.gridPositions.watches) {
         let elHour = this.table.createElement('div', 'timetable-cell hour-name');
         elHour.style.gridArea = `${i} / 1`;
         if ([5,8].includes(i)) elHour.innerHTML = '<div class="timeframe">Pause</div>';
      }

      this.table.querySelectorAll('.hour-name').forEach(el => el.onclick = () => {
         new ModalSelectTimeFrame("Unterrichtszeiten auswählen", (type) => {
            this.dm.setTimeFrameType(type);
            this.loadTimetable(this.result);
         });
      });

      timetableManager.render(this.table, this.gridPositions);
      this.loadWatches(result, this.table);


   }

   async loadWatches(view, elTable) {

      const watches = await this.dm.getWatchesByTeacher(view.id);
      const compiled = this.compileWatches(watches);

      for (let day=0; day<5; ++day) {
         for (let pos=0; pos<4; ++pos) {
            const cellWatches = compiled.filter(w => w.weekday-1 === day && w.position === pos);
            if (cellWatches.length > 0 && this.user.type === 'teacher') {
               let elCell = elTable.createElement('div', 'timetable-cell watch');
               elCell.style.gridArea = `${this.gridPositions.watches[pos]} / ${this.gridPositions.weekday[day]} / span 1`
               for (const watch of cellWatches) {
                  let elWatch = elCell.createElement('div', 'watch-item');
                  if (watch.removed) elWatch.classList.add('removed');
                  if (watch.type === 'add') elWatch.classList.add('add');
                  elWatch.innerText = watch.name;
                  //elWatch.style.height = "1.6rem";
                  elWatch.onclick = (event) => {
                     event.stopPropagation();
                     new ModalShowInfo("Aufsicht", '<p>'+watch.note+'</p>');
                  }                  
               }
            }
            else {
               let elBreak = this.table.createElement('div', `timetable-cell break sel-b-${day+1}-${pos}`);
               elBreak.style.gridArea = `${this.gridPositions.watches[pos]} / ${this.gridPositions.weekday[day]} / span 1`;
            }
         }
      }
      
   }

   compileWatches(watches) {

      const monday = this.currentMonday;
      const friday = new Date(monday);
      friday.setDate(monday.getDate() + 4);

      const displayWatches = [];

      // Aufsichten dieser Woche herausfiltern. Reguläre Aufsichten werden immer angezeigt; add und remove nur, wenn das Datum innerhalb der Woche liegt.
      const weekWatches = watches.filter(w => w.type === 'regular' || Date.fromString(w.date).inTimespan(monday.isoDate(), friday.isoDate()));

      // reguläre und zusätzliche Aufsichten eintragen
      for (let watch of weekWatches) {
         const watchDate = Date.fromString(watch.date);
         if (['regular', 'add'].includes(watch.type)) {
            displayWatches.push({
               type:    watch.type,
               weekday: watch.type === 'regular' ? watch.weekday : watchDate.getWeekday()+1,
               position: watch.position,
               name: watch.name,
               note: watch.note
            });
         }
      }

      // bisher eingetragene Aufsichten durch gelöschte modifizieren
      for (let watch of weekWatches) {
         if (watch.type === 'remove') {
            const weekday = Date.fromString(watch.date).getWeekday()+1;
            const found = displayWatches.find(w => w.weekday === weekday && w.position === watch.position && w.name === watch.name);
            if (found) found.removed = true;
            else {
               displayWatches.push({
                  type:    watch.type,
                  weekday: weekday,
                  position: watch.position,
                  name: watch.name,
                  note: watch.note,
                  removed: true
               });
            }
         }
      }

      return displayWatches;


   }

   load(loadData) {

      if (loadData) {
         this.user = this.dm.getUserSelf();
         this.result = Object.extend({}, this.user);

         this.tab.classList.add('timetable-user-' + this.user.type);

         /*
         if (this.user.type === 'pupil') {
            this.tab.querySelector('.statusbar').setStyles({
               height: 0,
               padding: 0,
               overflow: 'hidden'
            })
            //this.loadTimetable(this.result);
         }
         else if (this.user.type === 'teacher') {
            //this.loadTimetable(this.result);
         }
         */
         if (this.user.timetable) {
            this.setMode('current');
         }
         else {
            this.tab.querySelector('.main-content > .date').style.height = 0;
            this.tab.querySelector('.main-content > .date').style.overflow = 'hidden';
            this.setMode('regular');
         }

         this.tab.setAttribute('loaded', '');

      }



   }

};
